"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _IconRight = require("./IconRight");

var _ProjectSettings = require("../ProjectSettings.styles");

const Icon = /*#__PURE__*/_react.default.createElement(_IconRight.ArrowChevronRight, {
  tiny: true
});

// TODO: The icon is what causes the poor render performance
const Button = /*#__PURE__*/_react.default.memo(({
  project,
  isActive,
  onClick
}) => {
  return /*#__PURE__*/_react.default.createElement(_blocks.ActionItemButton, {
    key: project.jira_key,
    isActive: isActive,
    onClick: onClick,
    iconRight: Icon
  }, project.project_name);
}, (prevProps, nextProps) => prevProps.isActive === nextProps.isActive);

const ProjectsBox = /*#__PURE__*/_react.default.memo(props => {
  const {
    onProjectSelect,
    activeProject,
    projectList
  } = props;
  return /*#__PURE__*/_react.default.createElement(_ProjectSettings.SitesBoxWrapper, null, /*#__PURE__*/_react.default.createElement(_ProjectSettings.BoxHeader, null, /*#__PURE__*/_react.default.createElement(_ProjectSettings.BoxHeading, null, "Projects")), /*#__PURE__*/_react.default.createElement(_blocks.FilterList, {
    filterKey: "project_name",
    filterDelay: 500,
    items: projectList
  }, ({
    visible
  }) => {
    return /*#__PURE__*/_react.default.createElement(_ProjectSettings.SitesBoxContent, null, visible.map(project => /*#__PURE__*/_react.default.createElement(Button, {
      key: project.jira_key,
      project: project,
      isActive: project.jira_key === activeProject,
      onClick: onProjectSelect(project.jira_key)
    })));
  }));
}, (p, n) => p.activeProject === n.activeProject);

var _default = ProjectsBox;
exports.default = _default;
module.exports = exports.default;